import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  getComponentsList,
  getCustomMetaComponentsList,
  getProjectPropertiesComponentsList,
} from '../types/Components';
import { Field, change } from 'redux-form';
import FieldError from '../form/FieldError';

class SelectBox extends PureComponent {
  constructor(props) {
    super(props);
    this._onChange = this._onChange.bind(this);
  }

  _onChange(e) {
    this.props.onSelectChange(e);
    this.props.input.onChange(e);
  }

  render() {
    const { input, children, style, className, disabled } = this.props;

    return (
      <select
        {...input}
        style={style}
        className={className}
        onChange={this._onChange}
        disabled={disabled}
      >
        {children}
      </select>
    );
  }
}

export default class ComponentsSelect extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    field: PropTypes.string,
    formName: PropTypes.string,
    meta: PropTypes.object,
    customMetaComponents: PropTypes.bool,
    projectPropertiesComponents: PropTypes.bool,
    componentDefaultValue: PropTypes.any,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    disabled: PropTypes.bool,
  };

  buildComponentOptions = () => {
    const { customMetaComponents, projectPropertiesComponents } = this.props;

    let componentsList = getComponentsList();

    if (customMetaComponents) componentsList = getCustomMetaComponentsList();
    else if (projectPropertiesComponents)
      componentsList = getProjectPropertiesComponentsList();

    return componentsList.map(c => (
      <option key={c.option} value={c.option}>
        {c.title}
      </option>
    ));
  };

  onSelectChange = () => {
    const { formName, componentDefaultValue } = this.props;

    const defaultVal = componentDefaultValue || null;
    const dispatch = this.props.dispatch
      ? this.props.dispatch
      : this.props.meta.dispatch;

    // console.log('defaultVal', defaultVal);
    dispatch(change(formName, 'propValue', defaultVal));
  };

  render() {
    const {
      meta,
      field,
      className,
      formName,
      containerClassName,
      containerStyle,
      disabled,
    } = this.props;

    return (
      <div className={containerClassName} style={containerStyle}>
        <Field
          name={field}
          component={SelectBox}
          style={{ display: 'block', height: 38 }}
          className={className || 'form-control c-select'}
          onSelectChange={this.onSelectChange}
          formName={formName}
          disabled={disabled}
        >
          {this.buildComponentOptions()}
        </Field>
        {meta && <FieldError meta={meta} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/types/ComponentsSelect.js